'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var TableCell = _interopDefault(require('@material-ui/core/TableCell'));
var moment = _interopDefault(require('moment-timezone'));
var styledComponents = require('./styled-components.js');

var getTimeLinePositionInPx = function (timeMoment, calendarTableHeaderRef, calendarTableBodyRef) {
    var _a, _b, _c, _d, _e;
    var time = parseInt(timeMoment.format('X'), 10);
    var timezoneOffset = ((_a = timeMoment.utcOffset()) !== null && _a !== void 0 ? _a : 0) * 60;
    var currentTimeInSeconds = (time + timezoneOffset) % 86400;
    var headerRowHeight = (_c = (_b = calendarTableHeaderRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) !== null && _c !== void 0 ? _c : 0;
    var calendarBodyHeight = (_e = (_d = calendarTableBodyRef === null || calendarTableBodyRef === void 0 ? void 0 : calendarTableBodyRef.current) === null || _d === void 0 ? void 0 : _d.offsetHeight) !== null && _e !== void 0 ? _e : 0;
    var secondsInDay = 86400;
    var pxPosition = (currentTimeInSeconds / secondsInDay) * calendarBodyHeight;
    if (pxPosition <= 0 || pxPosition >= calendarBodyHeight)
        return 0;
    return pxPosition + headerRowHeight;
};
var tableCellGenerator = function (columns, theme) {
    var results = [];
    for (var i = 0; i < columns; i += 1) {
        var temp = [];
        for (var j = 0; j < 12 * 24; j += 1) {
            var hasBottomBorder = j % 6 === 5;
            var borderBottomStyle = 'none';
            if (hasBottomBorder) {
                borderBottomStyle = j % 12 === 5 ? 'dashed' : 'solid';
            }
            temp.push(React__default.createElement(styledComponents.DefaultTableCell, { key: "innerCell" + i + j, style: {
                    borderBottom: hasBottomBorder
                        ? "1px " + borderBottomStyle + " " + theme.palette.divider
                        : 'none',
                } }));
        }
        results.push(temp);
    }
    return results;
};
var getFiveMinuteTimeIntervals = function () {
    var count = 12 * 24;
    var result = [];
    for (var i = 0; i < count; i += 1) {
        result.push({ hr: Math.floor((i * 5) / 60), min: (i * 5) % 60 });
    }
    return result;
};
var getColumnNames = function (columns, namingFn) {
    var result = [];
    for (var i = 0; i < columns; i += 1) {
        result.push(namingFn(i));
    }
    return result;
};
var addTimeToAccumulator = function (timeStart, timeEnd, acc, curr, override) {
    var currentTarget = acc.find(function (el) {
        return el.timeStart.isSameOrBefore(timeStart) &&
            el.timeEnd.isAfter(timeStart) &&
            el.column === curr.column;
    });
    if (currentTarget) {
        if (timeEnd && timeEnd.isAfter(currentTarget.timeEnd)) {
            currentTarget.timeEnd = timeEnd;
        }
        if (override === 'start') {
            currentTarget.children.push(tslib.__assign(tslib.__assign({}, curr), { timeStart: timeStart }));
        }
        else if (override === 'end') {
            currentTarget.children.push(tslib.__assign(tslib.__assign({}, curr), { timeEnd: timeEnd }));
        }
        else {
            currentTarget.children.push(curr);
        }
        return;
    }
    var alternativeTarget = acc.find(function (el) {
        return el.timeStart.isSameOrBefore(timeEnd) &&
            el.timeEnd.isSameOrAfter(timeEnd) &&
            el.column === curr.column;
    });
    if (alternativeTarget) {
        if (timeStart && timeStart.isBefore(alternativeTarget.timeStart)) {
            alternativeTarget.timeStart = timeStart;
        }
        if (override === 'start') {
            alternativeTarget.children.push(tslib.__assign(tslib.__assign({}, curr), { timeStart: timeStart }));
        }
        else if (override === 'end') {
            alternativeTarget.children.push(tslib.__assign(tslib.__assign({}, curr), { timeEnd: timeEnd }));
        }
        else {
            alternativeTarget.children.push(curr);
        }
        return;
    }
    if (override === 'start') {
        acc.push({
            column: curr.column,
            timeStart: curr.timeStart,
            timeEnd: timeEnd,
            children: [tslib.__assign(tslib.__assign({}, curr), { timeStart: timeStart })],
        });
    }
    else if (override === 'end') {
        acc.push({
            column: curr.column,
            timeStart: timeStart,
            timeEnd: curr.timeEnd,
            children: [tslib.__assign(tslib.__assign({}, curr), { timeEnd: timeEnd })],
        });
    }
    else {
        acc.push({
            column: curr.column,
            timeStart: curr.timeStart,
            timeEnd: curr.timeEnd,
            children: [tslib.__assign(tslib.__assign({}, curr), { timeStart: timeStart })],
        });
    }
};
var getDarkness = function (event, childEvent) {
    if (event.children.length < 3)
        return 1;
    var i = event.children.indexOf(childEvent);
    var previousEventsWithMatchingStatus = event.children
        .filter(function (_, index) { return index < i; })
        .filter(function (c) { return c.status === childEvent.status; });
    if (i > 0) {
        if (childEvent.timeStart.isBefore(event.children[i - 1].timeEnd)) {
            return 1 + previousEventsWithMatchingStatus.length;
        }
        return previousEventsWithMatchingStatus.length;
    }
    return 1;
};
var getEventStyle = function (event, childEvent) {
    var timeStart = childEvent.timeStart, timeEnd = childEvent.timeEnd;
    var i = event.children.indexOf(childEvent);
    var fullDuration = moment.duration(event.timeEnd.diff(event.timeStart));
    var fullMinutes = fullDuration.asMinutes();
    var offsetDuration = moment.duration(timeStart.diff(event.timeStart));
    var topOffset = (offsetDuration.asMinutes() / fullMinutes) * 100;
    var timeEndForDuration = timeEnd;
    if (timeEnd.format('D') !== timeStart.format('D')) {
        timeEndForDuration = timeStart.clone().endOf('day');
    }
    var heightDuration = moment.duration(timeEndForDuration.diff(timeStart));
    var elementHeight = (heightDuration.asMinutes() / fullMinutes) * 100;
    var onlyTwoOverlapping = event.children.length === 2;
    var marginLeft = '0px';
    var width = '100%';
    if (i > 0) {
        // Current appointment start is earlier than previous appointment's end
        if (childEvent.timeStart.isBefore(event.children[i - 1].timeEnd)) {
            marginLeft = i * 10 + "px";
            width = "calc(100% - " + i * 10 + "px)";
        }
        else {
            marginLeft = (i - 1) * 10 + "px";
            width = "calc(100% - " + (i - 1) * 10 + "px)";
        }
    }
    if (onlyTwoOverlapping) {
        marginLeft = i === 1 ? '50%' : '0%';
        width = '50%';
    }
    var darkness = getDarkness(event, childEvent);
    return {
        style: {
            marginLeft: marginLeft,
            position: 'absolute',
            top: topOffset + "%",
            width: width,
            height: elementHeight + "%",
            backgroundColor: 'white',
            borderRadius: '6px',
        },
        darkness: darkness,
    };
};
var getTimeSlots = function (events) {
    return events
        .sort(function (a, b) {
        return a.timeStart.isBefore(b.timeStart) ? -1 : 1;
    })
        .reduce(function (acc, curr) {
        if (curr.timeStart.get('hours') > curr.timeEnd.get('hours')) {
            var startMoment = moment(curr.timeStart);
            addTimeToAccumulator(curr.timeStart, startMoment.endOf('day'), acc, curr, 'start');
            return acc;
        }
        addTimeToAccumulator(curr.timeStart, curr.timeEnd, acc, curr);
        return acc;
    }, []);
};
var generateColumnsGiven = function (columnCells, Component, theme, events) {
    if (events) {
        // the events 'should' come in sorted, but if not this guarantees it.
        var timeSlots = getTimeSlots(events);
        timeSlots.forEach(function (event) {
            var _a;
            var startHrs = event.timeStart.get('hours') * 60;
            var startMins = parseInt(event.timeStart.format('m'), 10);
            var startPosition = Math.floor((startHrs + startMins) / 5);
            var endHrs = event.timeEnd.get('hours') * 60;
            var endMins = parseInt(event.timeEnd.format('m'), 10);
            var endPosition = Math.ceil((endHrs + endMins) / 5);
            if (startPosition > endPosition) {
                var temp = startPosition;
                startPosition = endPosition;
                endPosition = temp;
            }
            var rowSpan = endPosition - startPosition;
            if (columnCells[event.column]) {
                var ts = event.timeStart, te = event.timeEnd, c = event.column;
                var endMinutes = te.minutes();
                var hasBottomBorder = endMinutes === 0 || endMinutes === 30;
                var borderBottomStyle = endMinutes === 30 ? 'dashed' : 'solid';
                var replacements = tslib.__spreadArrays([
                    React__default.createElement(TableCell, { key: "" + ts.format('HH:mm') + c, rowSpan: rowSpan, style: {
                            padding: '0px',
                            height: '12px',
                            backgroundColor: 'white',
                            borderBottom: hasBottomBorder
                                ? "1px " + borderBottomStyle + " " + theme.palette.divider
                                : 'none',
                        } },
                        event.children.length < 2 &&
                            event.children.map(function (_a) {
                                var _b, _c, _d;
                                var timeStart = _a.timeStart, timeEnd = _a.timeEnd, column = _a.column, status = _a.status, rest = tslib.__rest(_a, ["timeStart", "timeEnd", "column", "status"]);
                                return (React__default.createElement(Component, tslib.__assign({ key: "" + timeStart.toString() + timeEnd.toString() + ((_c = (_b = rest.data) === null || _b === void 0 ? void 0 : _b.contactId) !== null && _c !== void 0 ? _c : column) + ((_d = rest.data) === null || _d === void 0 ? void 0 : _d.name), column: column, status: status, timeStart: timeStart, timeEnd: timeEnd, showTooltip: false }, rest)));
                            }),
                        event.children.length >= 2 && (React__default.createElement("div", { style: { position: 'relative', height: '100%', borderRight: '1px solid #E3EBF6' } }, event.children.map(function (childEvent, index) {
                            var _a, _b, _c;
                            var timeStart = childEvent.timeStart, timeEnd = childEvent.timeEnd, column = childEvent.column, status = childEvent.status, rest = tslib.__rest(childEvent, ["timeStart", "timeEnd", "column", "status"]);
                            var _d = getEventStyle(event, childEvent), style = _d.style, darkness = _d.darkness;
                            var showTooltip = true;
                            var childrenLength = event.children.length;
                            // If it's the top appointment in the list or it's 2 side by side
                            if (index + 1 === childrenLength || childrenLength < 3) {
                                showTooltip = false;
                            }
                            return (React__default.createElement("div", { style: style, key: "" + timeStart.toString() + timeEnd.toString() + ((_b = (_a = rest.data) === null || _a === void 0 ? void 0 : _a.contactId) !== null && _b !== void 0 ? _b : column) + ((_c = rest.data) === null || _c === void 0 ? void 0 : _c.name) },
                                React__default.createElement(Component, tslib.__assign({ column: column, darkness: darkness, showTooltip: showTooltip, status: status, timeEnd: timeEnd, timeStart: timeStart }, rest))));
                        }))))
                ], Array(rowSpan - 1).fill(null));
                // mutation...
                (_a = columnCells[event.column]).splice.apply(_a, tslib.__spreadArrays([startPosition, rowSpan], replacements));
            }
        });
    }
    return columnCells;
};
var getChairColumnWidth = function (columns) { return (1 / columns) * 100 + "%"; };
var getFirstEventTime = function (events) {
    var timeSlots = getTimeSlots(events);
    if (timeSlots.length === 0)
        return null;
    return timeSlots[0].timeStart;
};
var getFirstDisplayTimeElement = function (events, timePadding) {
    if (timePadding === void 0) { timePadding = 30; }
    var startingTime = getFirstEventTime(events);
    if (!startingTime)
        return null;
    var minutes = startingTime.minutes();
    var closestMinuteInterval = minutes - (minutes % 5);
    var targetTime = startingTime
        .clone()
        .minutes(closestMinuteInterval)
        .subtract(timePadding, 'minute');
    var targetTimeKey = targetTime.isSame(startingTime, 'D') ? targetTime.format('H-m') : '0-0';
    var timeEl = document.querySelector("tr[data-key='" + targetTimeKey + "'");
    return timeEl;
};
var getScrollOptions = function (scrollPosition, scrollBehavior, scrollTarget, headerRef, bodyRef, timezone, events, scrollCoordinates) {
    var _a, _b, _c, _d, _e;
    if (!scrollTarget)
        return undefined;
    var scrollOptions = {
        behavior: scrollBehavior,
        left: 0,
        top: 0,
    };
    var headerHeight = (_b = (_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    var calendarHeight = (_c = scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.clientHeight) !== null && _c !== void 0 ? _c : 0;
    switch (scrollPosition) {
        case 'location':
            scrollOptions.left = (_d = scrollCoordinates === null || scrollCoordinates === void 0 ? void 0 : scrollCoordinates.left) !== null && _d !== void 0 ? _d : 0;
            scrollOptions.top = (_e = scrollCoordinates === null || scrollCoordinates === void 0 ? void 0 : scrollCoordinates.top) !== null && _e !== void 0 ? _e : 0;
            break;
        case 'currentTime': {
            var position = getTimeLinePositionInPx(moment().tz(timezone), headerRef, bodyRef);
            scrollOptions.top = Math.floor(position - (calendarHeight + headerHeight) / 2);
            break;
        }
        case 'firstEvent':
        default: {
            var startTimeEl = getFirstDisplayTimeElement(events);
            if (startTimeEl) {
                scrollOptions.top = startTimeEl.offsetTop - headerHeight;
            }
            break;
        }
    }
    return scrollOptions;
};

exports.generateColumnsGiven = generateColumnsGiven;
exports.getChairColumnWidth = getChairColumnWidth;
exports.getColumnNames = getColumnNames;
exports.getDarkness = getDarkness;
exports.getEventStyle = getEventStyle;
exports.getFirstDisplayTimeElement = getFirstDisplayTimeElement;
exports.getFirstEventTime = getFirstEventTime;
exports.getFiveMinuteTimeIntervals = getFiveMinuteTimeIntervals;
exports.getScrollOptions = getScrollOptions;
exports.getTimeLinePositionInPx = getTimeLinePositionInPx;
exports.tableCellGenerator = tableCellGenerator;
